import { render, staticRenderFns } from "./criticalvalue.vue?vue&type=template&id=9ae5883c&scoped=true&"
import script from "./criticalvalue.vue?vue&type=script&lang=js&"
export * from "./criticalvalue.vue?vue&type=script&lang=js&"
import style0 from "./criticalvalue.vue?vue&type=style&index=0&id=9ae5883c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae5883c",
  null
  
)

export default component.exports